import React, { useState, useMemo, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSort,
  faSortUp,
  faSortDown,
  faEllipsisVertical
} from '@fortawesome/free-solid-svg-icons';

import placeType from '../../../../../data/placetype.json';

import { getChildrenListInfo } from "../../actions";

import { localDateString } from "../../../../../components/helpers/datetranslate";

import { childrenscount } from "../../../../../components/helpers/wordsnumber";

import ActionsMenu from './menu';

import ChildDismissalModal from '../ChildrenOut/ChildDismissalModal';
import ChildTransferModal from '../ChildrenTransferModal/ChildTransferModal';

import './style.css';

const { translate } = placeType;


const translateFields=(data)=>{

    return data.map(r=>({
        _id: r._id,
        lastName: r.lastName,
        firstName: r.firstName,
        middleName: r.middleName,
        birthDate: localDateString(r.birthDate),
        documentNumber:r.birthCertificate,
        enrollmentDate: localDateString(r.dateFrom),
        placeType: translate[r.placeType],
        foodType:r.typeKitchen ? 'дієтичне' : 'звичайне',
        tPl: r.placeType
    }));
}


// Основной компонент таблицы
const ChildrenTable = ({
  id, group_id, 
  columnsConfig = [],
  onActionSelect,
  customProps = {},
  onChildrensList,
  groupNumber,
  groupName,
  allGroups,
  isArchive, 
  period,
  selectedDate,
  mode
}) => {

  const [data, setChildren] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [expandedActions, setExpandedActions] = useState("internal");
  const [activeMenuIndex, setActiveMenuIndex] = useState(null);
  const [selectedChild, setChildData] = useState({});
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [currentGroupInfo, setCurrentGroupInfo] = useState(null);

  

  useEffect(()=>{
  async function api() {
    const data = await getChildrenListInfo({id, group_id, archives: isArchive, period, selectedDate});
    if(data.length > 0) setChildren( translateFields(data) )
    if(onChildrensList) onChildrensList(data.length > 0 && data.map(r=>({ idChild: r._id, tPl: r.placeType})));
  }

    api();
  }, [group_id, selectedDate])

  // Конфигурация столбцов по умолчанию
  const defaultColumns = [
    {
      key: 'lastName',
      label: 'Прізвище',
      sortable: true,
      width: '12%'
    },
    {
      key: 'firstName',
      label: "Ім'я",
      sortable: true,
      width: '10%'
    },
    {
      key: 'middleName',
      label: 'По батькові',
      sortable: true,
      width: '12%'
    },
    {
      key: 'birthDate',
      label: 'Дата народження',
      sortable: true,
      width: '10%'
    },
    {
      key: 'documentNumber',
      label: 'Серія та номер свідоцтва про народження',
      sortable: true,
      width: '12%'
    },
    {
      key: 'enrollmentDate',
      label: 'Дата зарахування',
      sortable: true,
      width: '10%'
    },
    {
      key: 'placeType',
      label: 'Тип місця в групі',
      sortable: true,
      width: '10%'
    },
    {
      key: 'foodType',
      label: 'Тип харчування',
      sortable: true,
      width: '12%'
    },
    {
      key: 'actions',
      label: 'Дії',
      sortable: false,
      width: '12%'
    }
  ];

  const columns = columnsConfig.length > 0 ? columnsConfig : defaultColumns;

  // Функция сортировки
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Сортированные данные
  const sortedData = useMemo(() => {
    if (!sortConfig.key) return data;
    
    return [...data].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }, [data, sortConfig]);

  const getSortIcon = (columnKey) => {
    if (columnKey !== sortConfig.key) return faSort;
    return sortConfig.direction === 'asc' ? faSortUp : faSortDown;
  };

  const handleMenuToggle = (index) => {
    setActiveMenuIndex(activeMenuIndex === index ? null : index);
  };

  const handleMenuClose = () => {
    setActiveMenuIndex(null);
  };

  const handleActionSelect = (actionId, child) => {
    if(["edit", "view"].includes(actionId)) onActionSelect(actionId, child._id, group_id);

    setChildData(Object.assign({}, child, { 
    group: `${groupNumber} ${groupName}`, 
    id: child._id 
    }));

    // Сохраняем информацию о текущей группе
    setCurrentGroupInfo({
      _id: group_id,
      name: `${groupNumber} ${groupName}`
    });

    if (actionId === 'transfer') {
      setShowTransferModal(true);
      setExpandedActions("internal")
    } else if (actionId === 'withdraw') {
      setActiveMenuIndex("withdraw");
    } else if (actionId === 'transfer_external'){
      setExpandedActions("external");
      setShowTransferModal(true);
    } 

    setActiveMenuIndex(actionId);


    setChildData(Object.assign({}, child, { group: `${groupNumber} ${groupName}`, id: child._id}) );

    //setActiveMenuIndex(null);
  };



  return (
    <div className="children-table-container">
       <ChildDismissalModal
        show={activeMenuIndex == "withdraw"}
        onHide={() => setActiveMenuIndex(null)}
        child={selectedChild}
        kgId={id}
        onSuccess={()=>alert("Дитина вибута")}
      />
      <ChildTransferModal
        show={showTransferModal}
        onHide={() => setShowTransferModal(false)}
        child={selectedChild}
        kgId={id}
        currentGroup={currentGroupInfo}
        onSuccess={() => {
          // Перезагрузка данных
          //const data = await getChildrenListInfo({id, group_id});
          //if(data.length > 0) setChildren( translateFields(data) );
        }}
        allGroups={allGroups}
        mode={expandedActions}
      />
      <div className="table-responsive">
        <table className="table align-middle" style={{ fontSize: '14px' }}>
          <thead>
            <tr>
              {columns.map((column) => (
                <th 
                  key={column.key} 
                  style={{ 
                    width: column.width,
                    cursor: column.sortable ? 'pointer' : 'default',
                    color: '#262e35ff',
                    fontWeight: 600,
                    borderBottom: '1px solid #6c757d',
                    padding: '10px 8px'
                  }}
                  onClick={() => column.sortable && handleSort(column.key)}
                >
                  <div className="d-flex align-items-center">
                    {column.renderHeader ? column.renderHeader(column, customProps) : column.label}
                    {column.sortable && (
                      <FontAwesomeIcon 
                        icon={getSortIcon(column.key)} 
                        className="ms-1" 
                        style={{ fontSize: '12px' }}
                      />
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedData.map((child, index) => (
              <tr key={index} className={index % 2 === 0 ? '' : 'bg-light'}>
                {columns.map((column) => (
                  <td key={column.key} style={{ padding: '10px 8px', borderBottom: '1px solid #e9ecef', position: 'relative' }}>
                    {column.key === 'actions' ? (
                      <div className="actions-menu-container" style={{ position: 'relative', display: 'inline-block' }}>
                        <button
                          className="btn btn-sm btn-link text-decoration-none p-0"
                          onClick={() => handleMenuToggle(index)}
                          style={{ color: '#0d6efd' }}
                        >
                          <FontAwesomeIcon icon={faEllipsisVertical} />
                        </button>
                        
                        {activeMenuIndex === index && (
                          <ActionsMenu 
                            onActionSelect={(actionId) => handleActionSelect(actionId, child)}
                            onClose={handleMenuClose}
                            mode={mode}
                          />
                        )}
                      </div>
                    ) : column.renderCell ? (
                      column.renderCell(child, column, customProps)
                    ) : (
                      child[column.key]
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="table-footer-note">
        Всього в групі {data.length} {childrenscount(data.length)}, {data.filter(c => c.placeType === 'standart').length} на повному дні та {data.filter(c => c.placeType === 'without-bed').length} на короткотривалому перебуванні
      </div>
    </div>
  );
};


export default ChildrenTable;
